import { UNIT_BADGE_HEIGHT_PX } from "../unit-badge-tokens";

/** Chart grid border color — shared by ECharts grid and plot chrome. */
export const GRID_BORDER_COLOR = "#E4E5E2";

/** Axis tick label color, and the border on the crosshair time badge that sits among them. */
export const AXIS_LABEL_COLOR = "#838879";

/** Distance of a y-axis line from the plot grid edge — ECharts offset and gutter measurement both use this. */
export const Y_AXIS_BASE_OFFSET_PX = 10;

/** Y-axis tick label font size — must match Y_TICK_FONT. */
export const Y_TICK_FONT_SIZE_PX = 12;

/**
 * Must match the rendered style of the ECharts y-axis tick labels (axisLabel in
 * buildTimePanelOptions) — measured widths depend on it.
 * Uses generic sans-serif (ECharts default family); unit badges use Roboto via getBadgeFont — keep them
 * separate so tick measure stays tied to what ECharts paints.
 */
export const Y_TICK_FONT = `lighter ${Y_TICK_FONT_SIZE_PX}px sans-serif`;

/**
 * One style for both hover readouts: the per-series value tags (DOM, hover-values.tsx) and the
 * crosshair time badge (echarts, build-time-panel-options.ts). They sit a few pixels apart on the
 * same hover, so any of these drifting shows.
 *
 * The family is the exception — the badge keeps echarts' own, since Roboto rendered badly on canvas.
 */
export const HOVER_LABEL_FONT_SIZE_PX = 10;
export const HOVER_LABEL_RADIUS_PX = 4;
export const HOVER_LABEL_PADDING_X_PX = 2;
export const HOVER_LABEL_PADDING_Y_PX = 1;
export const HOVER_LABEL_BORDER_PX = 1;
export const HOVER_LABEL_FONT_FAMILY = "Roboto, sans-serif";
export const HOVER_LABEL_FONT = `400 ${HOVER_LABEL_FONT_SIZE_PX}px ${HOVER_LABEL_FONT_FAMILY}`;

/** Pull x-axis pointer label up into the band between grid bottom and tick labels. */
export const X_AXIS_POINTER_LABEL_MARGIN_PX = 1;

/** Push x-axis tick labels down so they sit below the crosshair badge. */
export const X_AXIS_TICK_LABEL_MARGIN_PX = 14;

export const X_AXIS_TICK_LABEL_FONT_SIZE_PX = 12;

/** Includes enough space below the baseline for letters such as "g" in month names. */
export const X_AXIS_TICK_LABEL_LINE_HEIGHT_PX = 14;

/** Space below the plot reserved for x-axis tick labels (margin + line height). */
export const X_AXIS_BAND_PX = X_AXIS_TICK_LABEL_MARGIN_PX + X_AXIS_TICK_LABEL_LINE_HEIGHT_PX;

/**
 * The top tick label is centered on its tick line, so half of it paints up into the headroom band.
 * Headroom has to cover that half or the badge sits on top of the label.
 */
const Y_TICK_LABEL_HALF_HEIGHT_PX = Y_TICK_FONT_SIZE_PX / 2;

/** Breathing room between the bottom of the badge and the top of the highest tick label. */
export const UNIT_BADGE_HEADROOM_EXTRA_PX = 12;

/**
 * Vertical plot clearance reserved above the highest labeled tick so the unit badge has a band of
 * its own to float in.
 */
export const UNIT_BADGE_HEADROOM_PX = UNIT_BADGE_HEIGHT_PX + Y_TICK_LABEL_HALF_HEIGHT_PX + UNIT_BADGE_HEADROOM_EXTRA_PX;
